const mutations = {
  getCorpSalesExcellences: (state, corp_sales_excellence) => {
    state.corp_sales_excellence = corp_sales_excellence;
  },
  getCorpSalesExcellence: (state, corp_sales_excellence_id) => {
    state.corp_sales_excellence_id = corp_sales_excellence_id;
  },
  postCorpSalesExcellence: (state, new_corp_sales_excellence) => {
    state.corp_sales_excellence.push(new_corp_sales_excellence);
  },
  putCorpSalesExcellence: (state, payload) => {
    state.corp_sales_excellence = state.corp_sales_excellence.map((corp_sales_excellence) => {
      if (corp_sales_excellence.corp_sales_excellence_id === payload.id) {
        return Object.assign({}, corp_sales_excellence, payload.corp_sales_excellenceData);
      }
      return corp_sales_excellence;
    });
  },
  delCorpSalesExcellence(state, id) {
    const index = state.corp_sales_excellence.findIndex(corp_sales_excellence => corp_sales_excellence.corp_sales_excellence_id == id);
    state.corp_sales_excellence.splice(index, 1);
  },
};

export default mutations;
